export default {"src":"/_next/static/media/architect-stamp.89bc6245.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};